import { createPartyRequest } from './helper';
export const postChangeUsernameMail = createPartyRequest({
    route: '/party/workflows/changeusernamemail',
    method: 'post',
    source: 'data',
});
